// extracted by mini-css-extract-plugin
export default {"header":"card_header__O4EfC","footer":"card_footer__soU5n"};